import Analytic from './analytics/show.jsx'
import { Route, Routes, Navigate } from 'react-router-dom'
import AnalyticsTable from './analytics/index.jsx'
import Monitoring from './monitoring/index.jsx'
import MonitoringWorkflows from './monitoring/workflows/index.jsx'
import Transaction from './transactions/show.jsx'
import Dashboards from './dashboard/index.jsx'
import ApDashboard from './dashboard/accounts_payable/index.jsx'
import ApliDashboard from './dashboard/accounts-payable-line-item/index.jsx'
import BgDashboard from './dashboard/budget/index.jsx'
import BudgetOverTimeDashboard from './dashboard/budget-over-time/index.jsx'
import GlDashboard from './dashboard/general_ledger/index.jsx'
import PcDashboard from './dashboard/pcard/index.jsx'
import PrDashboard from 'dashboard/payroll/index.jsx'
import PoDashboard from './dashboard/purchasing/index.jsx'
import RqDashboard from './dashboard/requisitions/index.jsx'
import VoDashboard from './dashboard/vendors/index.jsx'
import VendorDashboard from './dashboard/vendor/index.jsx'
import WorkflowDashboard from './dashboard/workflow/index.jsx'
import WorkflowPendingDashboard from './dashboard/workflow-pending/index.jsx'
import ContractsDashboard from './dashboard/contracts/index.jsx'
import CardholderDashboard from './dashboard/cardholder/index.jsx'
import VendorRemittanceDashboard from './dashboard/vendor-remittance/index.jsx'
import OkgtDashboard from './dashboard/ok-grants/index.jsx'
import UbAccountsDashboard from './dashboard/ub_accounts/index.jsx'
import UbAdjustmentsDashboard from './dashboard/ub_adjustments/index.jsx'
import UbBillingDashboard from './dashboard/ub_billing/index.jsx'
import UbConsumptionDashboard from './dashboard/ub_consumption/index.jsx'
import UbFixedUsageDashboard from './dashboard/ub_fixed_usage/index.jsx'
import Employees from './employees/index.jsx'
import Employee from './employees/show.jsx'
import Vendors from './vendors/index.jsx'
import Vendor from './vendors/show.jsx'
import Settings from './settings/index.jsx'
import Saved from './saved/index.jsx'
import Policies from './policies/index'
import Upload from './upload/index'
import Export from './exports/index'
import AdminRoutes from './admin/AdminRoutes'
import SampleShow from './samples/show'
import ReportBuilderShow from './report-builder/show.jsx'
import Ask from './ask/index.jsx'
import { isAssistantUser } from './ask/access'
import { useContext } from 'react'
import UserContext from 'context/user-context'

function AuthenticatedUser() {
  const user = useContext(UserContext)
  return (
    <Routes>
      <Route path="/" element={<Navigate replace to="/dashboards" />} />
      <Route path="/dashboards" element={<Dashboards />} />
      <Route path="/dashboards/accounts-payable" element={<ApDashboard />} />
      <Route path="/dashboards/accounts-payable-line-item" element={<ApliDashboard />} />
      <Route path="/dashboards/budget" element={<BgDashboard />} />
      <Route
        path="/dashboards/budget-over-time"
        element={<BudgetOverTimeDashboard />}
      />
      <Route path="/dashboards/general-ledger" element={<GlDashboard />} />
      <Route path="/dashboards/purchase-orders" element={<PoDashboard />} />
      <Route path="/dashboards/requisitions" element={<RqDashboard />} />
      <Route path="/dashboards/pcard" element={<PcDashboard />} />
      <Route path="/dashboards/payroll" element={<PrDashboard />} />
      <Route
        path="/dashboards/vendor-audit-log"
        element={<VendorDashboard />}
      />
      <Route path="/dashboards/vendors" element={<VoDashboard />} />
      <Route path="/dashboards/vendor-remittance" element={<VendorRemittanceDashboard />} />
      <Route path="/dashboards/workflow" element={<WorkflowDashboard />} />
      <Route
        path="/dashboards/pending-workflow"
        element={<WorkflowPendingDashboard />}
      />
      <Route path="/dashboards/contracts" element={<ContractsDashboard />} />
      <Route path="/dashboards/cardholder" element={<CardholderDashboard />} />
      <Route path="/dashboards/ok-grants" element={<OkgtDashboard />} />
      <Route path="/dashboards/utility-billing-accounts" element={<UbAccountsDashboard />} />
      <Route path="/dashboards/utility-billing-adjustments" element={<UbAdjustmentsDashboard />} />
      <Route path="/dashboards/utility-billing-billing" element={<UbBillingDashboard />} />
      <Route path="/dashboards/utility-billing-consumption" element={<UbConsumptionDashboard />} />
      <Route path="/dashboards/utility-billing-fixed-usage" element={<UbFixedUsageDashboard />} />
      <Route path="/vendors" exact={true} element={<Vendors />} />
      <Route path="/vendors/:id" exact={true} element={<Vendor />} />
      <Route path="/transactions/:id" element={<Transaction />} />
      <Route path="/employees" exact={true} element={<Employees />} />
      <Route path="/employees/:id" element={<Employee />} />
      <Route path="/samples" element={<Navigate replace to="/dashboards" />} />
      <Route path="/samples/:id" element={<SampleShow />} />
      <Route path="/analytics" exact={true} element={<AnalyticsTable />} />
      <Route path="/analytics/:id" element={<Analytic />} />
      <Route path="/monitoring" element={<MonitoringWorkflows />} />
      <Route path="/monitoring/:workflowSlug" element={<Monitoring />} />
      <Route path="/saved" element={<Saved />} exact={true} />
      <Route path="/settings" element={<Settings />} exact={true} />
      {/* Account Groups moved into Settings. Kept as a redirect so existing links and
          bookmarks land on the tab rather than a blank page. */}
      <Route
        path="/account-groups"
        element={<Navigate to="/settings#account-groups" replace={true} />}
        exact={true}
      />
      <Route path="/policies" element={<Policies />} exact={true} />
      <Route path="/policies/:id" element={<Policies />} exact={true} />
      <Route path="/upload" element={<Upload />} exact={true} />
      <Route path="/exports" element={<Export />} exact={true} />
      {/* Admin Routes - Always register route, authorization handled inside AdminRoutes */}
      <Route path="/admin/*" element={<AdminRoutes />} />
      {/* Multi-dataset report builder (beta — gated to beta users; others fall through to the
          catch-all redirect below). Reports are listed on the Views index now; /reports is kept
          only so existing links and bookmarks land there rather than on a blank page. */}
      {user?.is_beta && (
        <>
          <Route path="/reports" element={<Navigate replace to="/dashboards" />} exact={true} />
          <Route path="/reports/:id" element={<ReportBuilderShow />} exact={true} />
          {/* The Assistant is further limited to ThirdLine admins; see ask/access.js. */}
          {isAssistantUser(user) && (
            <>
              <Route path="/ask" element={<Ask />} exact={true} />
              <Route path="/ask/:id" element={<Ask />} exact={true} />
            </>
          )}
          {/* Report blueprints moved into Settings. Kept as a redirect so existing links and
              bookmarks land on the tab rather than a blank page. */}
          <Route
            path="/report-blueprints"
            element={<Navigate to="/settings#report-blueprints" replace={true} />}
            exact={true}
          />
        </>
      )}
      {/* Risk assessment routes */}
      <Route path="/risk" element={<Navigate replace to="/dashboards" />} />
      <Route
        path="/risk-assessment"
        element={<Navigate replace to="/dashboards" />}
      />
      {/* Catch-all: redirect unknown routes to home */}
      <Route path="*" element={<Navigate replace to="/dashboards" />} />
    </Routes>
  )
}

export default AuthenticatedUser
